import { Icon } from "@zapier/design-system";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import styles from "./AssetTag.module.css";

const ICON_SIZE = 18;
const ICON_COLOR = "BrandOrange";

type Props = {
  assetType: "zap" | "table" | "interface" | "chatbot";
};

const iconMap = {
  zap: "miscBoltAltFill" as const,
  table: "navTables" as const,
  interface: "navInterfaces" as const,
  chatbot: "navAIChatbot" as const,
};

export function AssetTag({ assetType }: Props) {
  return (
    <div className={styles.stepTypeWrapper}>
      <Icon size={ICON_SIZE} color={ICON_COLOR} name={iconMap[assetType]} />
      <div className={styles.text}>{capitalizeFirstLetter(assetType)}</div>
    </div>
  );
}
